import firebase from 'firebase/app'
import 'firebase/analytics'

export function logEvent(key, value) {
    return firebase.analytics().logEvent(key, value)
}